import ProductId from "~/constants/ProductId";

const ProductSquareFeet = {
  [ProductId.PUBLISH_TOUR]: 0,
  // Immersive 3D Tour
  // Pricing method with base price and per panorama
  [ProductId.IMMERSIVE_3D_TOUR_PANORAMAS]: 0,
  [ProductId.IMMERSIVE_3D_TOUR_PANORAMAS_WITH_FLOOR_PLAN]: 0,
  [ProductId.IMMERSIVE_3D_TOUR_BASE]: 0,
  // Pricing method with flat fee
  [ProductId.IMMERSIVE_3D_TOUR]: 0,
  [ProductId.FLOOR_PLAN]: 0,
  // Pricing method per square feet
  [ProductId.IMMERSIVE_3D_TOUR_1000_SQ_FT]: 1000,
  [ProductId.IMMERSIVE_3D_TOUR_WITH_FLOOR_PLAN_1000_SQ_FT]: 1000,
  [ProductId.IMMERSIVE_3D_TOUR_0_2500_SQ_FT]: 2500,
  [ProductId.IMMERSIVE_3D_TOUR_WITH_FLOOR_PLAN_0_2500_SQ_FT]: 2500,
  [ProductId.IMMERSIVE_3D_TOUR_2501_3500_SQ_FT]: 3500,
  [ProductId.IMMERSIVE_3D_TOUR_WITH_FLOOR_PLAN_2501_3500_SQ_FT]: 3500,
  [ProductId.IMMERSIVE_3D_TOUR_3501_5000_SQ_FT]: 5000,
  [ProductId.IMMERSIVE_3D_TOUR_WITH_FLOOR_PLAN_3501_5000_SQ_FT]: 5000,
  [ProductId.IMMERSIVE_3D_TOUR_5001_7500_SQ_FT]: 7500,
  [ProductId.IMMERSIVE_3D_TOUR_WITH_FLOOR_PLAN_5001_7500_SQ_FT]: 7500,
  [ProductId.IMMERSIVE_3D_TOUR_7501_10000_SQ_FT]: 7500,
  [ProductId.IMMERSIVE_3D_TOUR_WITH_FLOOR_PLAN_7501_10000_SQ_FT]: 7500,
};

export default ProductSquareFeet;
